<div class="paddingright5 min-height-50"  [ngClass]="[showHistory ? 'mat-elevation-z2 no-pad market-height-limit' : '' ]">
  <markets-sidemarket #market (marketIdChange)="onMarketIDChange($event)"></markets-sidemarket>
</div>

<div class="mt-1 min-height-50 stats-table-limit" *ngIf="showHistory" [ngClass]="[showHistory ? 'mat-elevation-z2 no-pad trade-height-limit' : '' ]">
  <markets-statistics #tradeHistory (valueChange)="onValueChange($event)"></markets-statistics>
</div>
<!-- Chat disabled -->
<!-- <app-chat *ngIf="exchangeName !== 'burnx'"  [hidden]="!showChat" (close)="showChat = false" #chat></app-chat> -->
